import { PureQueryOptions, gql } from '@apollo/client/core'

export interface MarketSpecificationEntry {
  key: string
  value: {
    // Added via the local schema overlay until the backend deploys — nullable,
    // treat null/undefined as false. See client-schema.graphql.
    isBase?: boolean | null
  }
}

export interface MarketsSpecificationData {
  questionnaireAggV2: {
    projectId: string
    marketsSpecification?: MarketSpecificationEntry[] | null
  } | null
}

/**
 * `questionnaireAggV2` is a project-level aggregate fetched by any one of the
 * project's survey ids; it returns `marketsSpecification` for every market in
 * the project, keyed by market (survey) id. So a single query surfaces
 * `isBase` for all markets, and the base market is derived client-side as the
 * one whose `isBase === true` (there is no top-level base-survey field).
 */
export const GET_MARKETS_SPECIFICATION = gql`
  query marketsSpecificationV2($surveyId: ID!) {
    questionnaireAggV2(surveyId: $surveyId) {
      projectId
      marketsSpecification {
        key
        value {
          isBase
        }
      }
    }
  }
`

export const marketsSpecificationRefetchQuery: (
  surveyId: string
) => PureQueryOptions = (surveyId) => ({
  query: GET_MARKETS_SPECIFICATION,
  context: { clientName: 'questionnaire' },
  variables: { surveyId }
})
